const registerWrappingMedia = (Alpine) => {
    Alpine.data('wrappingMedia', () => ({
        minGutter: 30,
        maxBleedRatio: 0.15,
        update() {
            const el = this.$el
            const style = window.getComputedStyle(el)
            const floatSide = style.cssFloat || style.float || 'none'

            if (floatSide === 'none') {
                el.style.marginLeft = ''
                el.style.marginRight = ''
                return
            }

            const container = el.closest('.js-wrapping-elements-container') || el.parentElement
            if (!container) {
                el.style.marginLeft = ''
                el.style.marginRight = ''
                return
            }

            const rect = container.getBoundingClientRect()
            const viewportWidth = document.documentElement.clientWidth || window.innerWidth
            const containerWidth = rect.width
            const desiredBleed = containerWidth * this.maxBleedRatio

            if (floatSide === 'left') {
                let bleed = desiredBleed
                const maxAllowed = Math.max(0, rect.left - this.minGutter)
                if (bleed > maxAllowed) bleed = maxAllowed
                const px = Math.round(bleed)
                el.style.marginLeft = px > 0 ? `-${px}px` : ''
                el.style.marginRight = ''
                // Safety pass: ensure final gutter >= minGutter
                const elRect = el.getBoundingClientRect()
                const gutter = Math.max(0, elRect.left)
                if (gutter < this.minGutter) {
                    const adjust = this.minGutter - gutter
                    const newPx = Math.max(0, px - Math.ceil(adjust))
                    el.style.marginLeft = newPx > 0 ? `-${newPx}px` : ''
                }
            } else if (floatSide === 'right') {
                let bleed = desiredBleed
                const maxAllowed = Math.max(0, (viewportWidth - rect.right) - this.minGutter)
                if (bleed > maxAllowed) bleed = maxAllowed
                const px = Math.round(bleed)
                el.style.marginRight = px > 0 ? `-${px}px` : ''
                el.style.marginLeft = ''
                // Safety pass: ensure final gutter >= minGutter
                const elRect = el.getBoundingClientRect()
                const gutter = Math.max(0, (document.documentElement.clientWidth || window.innerWidth) - elRect.right)
                if (gutter < this.minGutter) {
                    const adjust = this.minGutter - gutter
                    const newPx = Math.max(0, px - Math.ceil(adjust))
                    el.style.marginRight = newPx > 0 ? `-${newPx}px` : ''
                }
            }
        }
    }))
}

export default {
    init(Alpine) {
        registerWrappingMedia(Alpine)
    }
}


